/**
 * Batch fields (Batch amount, Batch delay in minutes).
 * Shown when "Send in batches" is checked. Delay is entered in minutes; the create
 * mutation converts it to seconds (× 60) for the SMSWiser API.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { Input } from '@/components/ui';

export interface BatchFieldsProps {
  batchAmount: number | undefined;
  setBatchAmount: (v: number | undefined) => void;
  batchDelay: number | undefined;
  setBatchDelay: (v: number | undefined) => void;
  isBusy?: boolean;
  compact?: boolean;
}

const toNum = (v: string): number | undefined => (v ? Number(v) : undefined);

export const BatchFields: FC<BatchFieldsProps> = ({
  batchAmount,
  setBatchAmount,
  batchDelay,
  setBatchDelay,
  isBusy = false,
  compact = false,
}) => {
  const inputClass = compact ? 'h-7 min-w-0 text-xs' : 'h-9';
  const labelClass = compact
    ? 'mb-0.5 block text-[10px] text-muted-foreground'
    : 'mb-1 block text-xs text-muted-foreground';
  const fieldClass = 'flex min-w-0 flex-col';
  const wrapperClass = compact
    ? 'col-span-full ml-5 grid min-w-0 grid-cols-1 gap-3 sm:grid-cols-2'
    : 'ml-6 grid grid-cols-1 gap-3 sm:grid-cols-2';

  return (
    <div className={wrapperClass} data-testid="batch-fields">
      <div className={fieldClass}>
        <label className={labelClass}>Batch amount</label>
        <Input
          type="number"
          min={1}
          value={batchAmount ?? ''}
          onChange={(e) => setBatchAmount(toNum(e.target.value))}
          disabled={isBusy}
          className={inputClass}
        />
      </div>
      <div className={fieldClass}>
        <label className={labelClass}>Batch delay (minutes)</label>
        <Input
          type="number"
          min={1}
          value={batchDelay ?? ''}
          onChange={(e) => setBatchDelay(toNum(e.target.value))}
          disabled={isBusy}
          className={inputClass}
        />
      </div>
    </div>
  );
};
